var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',{class:{ 'mb-1': _vm.config.legend },attrs:{"justify":"center"}},[_c('svg',{ref:"graph",style:({
        maxWidth: _vm.width ? `${_vm.width}px` : undefined,
        maxHeight: _vm.height ? `${_vm.height}px` : undefined
      }),attrs:{"width":_vm.width,"height":_vm.height}})]),(_vm.graphFootnote)?_c('div',{staticClass:"results-tip text-center highlight--text text-body-2 pb-1"},[_c('span',[_vm._v(_vm._s(_vm.graphFootnote))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }